export const SECURE = {
  MUTATIONS: {
    SET_USER_DATA: 'app-secure-set-user-data',
    AUTH_IN_PROGRESS: 'app-secure-set-auth-in-progress'
  },
  ACTIONS: {
    CHECK: 'app-secure-check'
  },
  GETTERS: {
    USER_DATA: 'app-secure-get-user-data',
    AUTH_IN_PROGRESS: 'app-secure-get-auth-in-progress'
  }
}
